export default function ofType(enumerable, ctor) {
    return enumerable.where((item) => item instanceof ctor);
}
